import type { OnDestroy, PipeTransform } from '@angular/core';
import { ChangeDetectorRef, inject, Pipe } from '@angular/core';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { IContentStore } from '@app/interface/content/content-store.interface';

@Pipe({
  name: 'ltTranslate',
  pure: false
})
export class LtTranslatePipe implements PipeTransform, OnDestroy {
  private contentStore: IContentStore = inject(angularjs.ContentStore);
  private rootScope: ng.IRootScopeService = inject(angularjs.$rootScope);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private listenerUnsubscribe?: Function;

  constructor() {
    this.setupLanguageChangeListener();
  }

  transform(key: string, params?: { [key: string]: string }): string {
    if (!key) {
      return '';
    }
    return this.contentStore.translate(key, params);
  }

  ngOnDestroy(): void {
    if (this.listenerUnsubscribe) {
      this.listenerUnsubscribe();
    }
  }

  private setupLanguageChangeListener(): void {
    this.listenerUnsubscribe = this.rootScope.$on('contentChanged', () => {
      this.cdr.markForCheck();
    });
  }
}
